import { useSetAtom } from 'jotai'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { updateSmallItemVisibility } from './request'
import { useRequestState } from '../../../../../../../server/use-request-state'
import { templateDetailAtom } from '../atom'

export const useUpdateSmallItemVisibility = () => {
  const {
    requestDone,
    requestFailed,
    requestStarted,
    requesting,
    errorMessage,
  } = useRequestState()
  const toast = useMirohaToast()
  const setAtom = useSetAtom(templateDetailAtom)

  const request = async ({
    trialUid,
    templateUid,
    smallItemUids,
    trialHospitalUids,
  }: {
    trialUid: string
    templateUid: string
    smallItemUids: string[]
    trialHospitalUids: string[]
  }) => {
    try {
      requestStarted()
      await updateSmallItemVisibility({
        trialUid,
        templateUid,
        smallItemUids,
        trialHospitalUids,
      })

      toast({
        status: 'success',
        title:
          '医療機関設定を更新しました。テンプレート編集内容は保存されていないのでご注意ください。',
      })
      setAtom({
        type: 'updateSmallItemViewableHospitalUids',
        smallItemUids,
        trialHospitalUids,
      })
      requestDone()
    } catch (error) {
      requestFailed(error.message)
      throw error
    }
  }

  return {
    request,
    requesting,
    errorMessage,
  }
}
